import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, NavParams, ToastController} from 'ionic-angular';

import { Rodeo } from '../../../../model/rodeo';

import { Observable } from 'rxjs';
import { ReportsService } from '../../../../services/reports.service';
import { ContestantPaidItemReport } from 'model/contestant-paid-item-report.model';
import { PrintService } from '../../../../services/print-service';

@Component({
    selector: 'page-contestant-paid-report',
    templateUrl: 'report-contestant-paid-sheet.html'
})
export class ContestantPaidReport implements OnInit {
    @Input('rodeo') rodeo: Rodeo;
    
    popoverActive = false;
    paidContestantReport: ContestantPaidItemReport;

    currentTime: Date = new Date();

    printing: boolean;
    searchName: string;

    searchChangeObservable;

    private isLoading = false;

    constructor(
        private navParams: NavParams,
        private reportService: ReportsService,
        private toast: ToastController,
        private printService: PrintService,
        private loader: LoadingController
    ) { }

    async ngOnInit() {
        if (!this.rodeo)
            this.rodeo = this.navParams.get('rodeo');

        await this.load();
    }

    onNameSearchChange(searchValue) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(700)
                .distinctUntilChanged()
                .subscribe((text) => {
                    this.load();
                });
        }

        this.searchChangeObservable.next(searchValue);
    }

    async download(mode: 'pdf' | 'csv') {
        const loader = this.loader.create({
            content: `Generating Paid Items ${mode}...`
        })

        await loader.present();

        try {
            switch (mode) {
                case 'pdf':
                    await this.reportService.getContestantPaidReportPdf(this.rodeo.id, this.searchName);
                    break;
                case 'csv':
                    console.log('Cannot download csv yet');
                    break;
            }
        } catch (err) {
            console.error(err);
        } finally {
            loader.dismiss();
        }
       
    }

    async print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        this.printing = true;
        await this.printService.print(this.paidContestantReport.rodeo);
        this.printing = false;
        this.popoverActive = false;
    }

    async load() {
        if (this.isLoading) return;
        
        this.isLoading = true;
        
        try {
            const searchName = this.searchName || undefined;
            this.paidContestantReport = await this.reportService.getContestantPaidReportInfo(this.rodeo.id, searchName);
            this.currentTime = new Date();
            
            // console.log(this.paidContestantReport);
        } catch (err) {
            console.error(err);
            this.toast.create({
                message: 'Could not generate report',
                duration: 2500
            }).present();
        } finally {
            this.isLoading = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-contestant-paid-sheet.ts